import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../components/base/SEO';

export default function ScreenAddictionPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Ekran Bağımlılığı ve Dijital Denge | Çocuk Psikoloğu"
        description="Ekran bağımlılığı tedavisi ve dijital denge danışmanlığı. Oyun bağımlılığı, sosyal medya bağımlılığı ve aşırı ekran kullanımı için profesyonel destek. Dijital ebeveynlik stratejileri ve sağlıklı ekran süresi yönetimi."
        keywords="ekran bağımlılığı, oyun bağımlılığı, sosyal medya bağımlılığı, dijital denge, ekran süresi, dijital ebeveynlik, teknoloji bağımlılığı"
        canonical="https://psikologesraerten.com/ekran-bagimliligi"
      />
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 lg:px-8 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/22eb2655a5fefcd366d1f025a3b8bd68.jpg"
            alt="Ekran Bağımlılığı"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/50"></div>
        </div>
        <div className="relative max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <span className="inline-block px-4 py-1.5 bg-orange-500/20 text-orange-300 text-sm font-medium rounded-full mb-6">
              Dijital Çağın Sorunu
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Ekran Bağımlılığı ve Dijital Denge
            </h1>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Çocuğunuzun dijital dünya ile sağlıklı bir ilişki kurmasına yardımcı oluyorum. Ekran bağımlılığı konusunda profesyonel destek alın.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center px-8 py-3.5 bg-teal-500 text-white font-medium rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Randevu Al
              <i className="ri-arrow-right-up-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Problem Tanımı */}
      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-sm text-orange-600 font-semibold mb-4 block">GÜNÜMÜZÜN GERÇEKLİĞİ</span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Ekran Bağımlılığı Nedir?
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Günümüzde çocuklar ve ergenler dijital cihazlarla çok erken yaşta tanışıyor. Ekran bağımlılığı, bireyin günlük yaşamını, ilişkilerini ve sorumluluklarını olumsuz etkileyecek düzeyde dijital cihazlara bağımlı hale gelmesidir.
              </p>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Bu durum sosyal gelişimi, akademik başarıyı ve duygusal sağlığı ciddi şekilde etkileyebilir. Erken müdahale ve doğru yaklaşımlarla bu sorunun üstesinden gelmek mümkündür.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-orange-50 rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl mb-4">
                    <i className="ri-smartphone-line text-orange-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Günlük 6+ Saat</h4>
                  <p className="text-sm text-gray-600">Çocukların ortalama ekran süresi</p>
                </div>
                <div className="bg-teal-50 rounded-2xl p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
                    <i className="ri-user-heart-line text-teal-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">%70 Ebeveyn</h4>
                  <p className="text-sm text-gray-600">Ekran süresi konusunda endişeli</p>
                </div>
              </div>
            </div>
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=young%20child%20sitting%20alone%20staring%20at%20tablet%20screen%20in%20dimly%20lit%20room%20concerned%20parent%20watching%20from%20doorway%20digital%20device%20addiction%20concept%20screen%20time%20management%20family%20concern%20about%20technology%20overuse%20modern%20parenting%20challenges%20soft%20dramatic%20lighting%20showing%20isolation%20and%20disconnection%20from%20real%20world%20activities&width=900&height=700&seq=screenaddiction1&orientation=landscape"
                alt="Ekran Bağımlılığı"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Belirtiler */}
      <section className="py-20 px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-sm text-teal-600 font-semibold mb-4 block">BELİRTİLER</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Ekran Bağımlılığının İşaretleri
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Çocuğunuzda aşağıdaki belirtileri gözlemliyorsanız, profesyonel destek almanın zamanı gelmiş olabilir.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-2xl mb-6">
                <i className="ri-emotion-sad-line text-red-500 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Duygusal Tepkiler</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Cihaz alındığında aşırı öfke, huzursuzluk veya kaygı gösterme. Ekran olmadan sakinleşememe.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-2xl mb-6">
                <i className="ri-time-line text-orange-500 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Zaman Kontrolü Kaybı</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Ekran başında geçirilen sürenin farkında olmama, saatlerin nasıl geçtiğini anlayamama.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-yellow-100 rounded-2xl mb-6">
                <i className="ri-book-open-line text-yellow-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Akademik Düşüş</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Okul performansında belirgin düşüş, ödevleri yapmakta isteksizlik, konsantrasyon güçlüğü.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-2xl mb-6">
                <i className="ri-group-line text-teal-500 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Sosyal İzolasyon</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Arkadaşlarla yüz yüze vakit geçirmekten kaçınma, aile etkinliklerine katılmak istememe.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-indigo-100 rounded-2xl mb-6">
                <i className="ri-moon-line text-indigo-500 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Uyku Problemleri</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Geç saatlere kadar ekran kullanımı, uyku düzeninin bozulması, sabahları uyanmakta zorluk.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-pink-100 rounded-2xl mb-6">
                <i className="ri-eye-off-line text-pink-500 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Gizli Kullanım</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Ekran kullanımını gizleme, yalan söyleme, cihazı gizlice kullanma davranışları.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tedavi Yaklaşımı */}
      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20family%20moment%20parent%20and%20child%20playing%20board%20game%20together%20at%20home%20cozy%20living%20room%20setting%20natural%20light%20happy%20engaged%20interaction%20quality%20time%20without%20screens%20alternative%20activities%20healthy%20family%20bonding%20soft%20warm%20colors%20professional%20photography%20style&width=900&height=700&seq=familyactivity1&orientation=landscape"
                alt="Aile Aktivitesi"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="order-1 lg:order-2">
              <span className="text-sm text-teal-600 font-semibold mb-4 block">TEDAVİ YAKLAŞIMI</span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Dijital Denge Nasıl Sağlanır?
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Ekran bağımlılığı tedavisinde bütüncül bir yaklaşım benimsiyorum. Hem çocuk hem de aile ile birlikte çalışarak kalıcı değişimler oluşturuyoruz.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <div>
                    <span className="font-medium text-gray-900">Bireysel Değerlendirme</span>
                    <p className="text-sm text-gray-600 mt-1">Çocuğun ekran kullanım alışkanlıklarının detaylı analizi</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <div>
                    <span className="font-medium text-gray-900">Aile Eğitimi</span>
                    <p className="text-sm text-gray-600 mt-1">Ebeveynler için dijital ebeveynlik stratejileri</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <div>
                    <span className="font-medium text-gray-900">Sınır Belirleme</span>
                    <p className="text-sm text-gray-600 mt-1">Sağlıklı ekran süresi kuralları oluşturma</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <div>
                    <span className="font-medium text-gray-900">Alternatif Aktiviteler</span>
                    <p className="text-sm text-gray-600 mt-1">Ekran dışı eğlenceli etkinlikler keşfetme</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <div>
                    <span className="font-medium text-gray-900">Takip ve Destek</span>
                    <p className="text-sm text-gray-600 mt-1">Düzenli görüşmelerle ilerlemenin izlenmesi</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Çalışma Alanları */}
      <section className="py-20 px-6 lg:px-8 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-sm text-orange-600 font-semibold mb-4 block">ÇALIŞMA ALANLARI</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Hangi Konularda Destek Sağlıyorum?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl mr-4 flex-shrink-0">
                  <i className="ri-gamepad-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Oyun Bağımlılığı</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Video oyunları ve mobil oyunlara aşırı bağımlılık, oyun içi satın almalar, online oyun sorunları.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mr-4 flex-shrink-0">
                  <i className="ri-instagram-line text-pink-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Sosyal Medya Bağımlılığı</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Sürekli sosyal medya kontrolü, beğeni takıntısı, FOMO (kaçırma korkusu), özgüven sorunları.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-xl mr-4 flex-shrink-0">
                  <i className="ri-video-line text-red-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Video İzleme Bağımlılığı</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    YouTube, TikTok gibi platformlarda saatlerce video izleme, içerik tüketimi kontrolsüzlüğü.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl mr-4 flex-shrink-0">
                  <i className="ri-parent-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Dijital Ebeveynlik</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Ebeveynler için ekran süresi yönetimi, güvenli internet kullanımı, yaşa uygun içerik kontrolü.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* İpuçları */}
      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-12 md:p-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <span className="text-sm text-teal-400 font-semibold mb-4 block">EBEVEYNLER İÇİN</span>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  Dijital Denge İçin Pratik İpuçları
                </h2>
                <p className="text-gray-300 mb-8 leading-relaxed">
                  Evde uygulayabileceğiniz basit ama etkili stratejilerle çocuğunuzun ekran kullanımını dengelemeye başlayabilirsiniz.
                </p>
                <Link
                  to="/iletisim"
                  className="inline-flex items-center px-8 py-3.5 bg-teal-500 text-white font-medium rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Detaylı Bilgi Alın
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
              <div className="space-y-4">
                <div className="bg-white/10 backdrop-blur rounded-xl p-5">
                  <div className="flex items-center">
                    <span className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white text-sm font-bold rounded-full mr-4">1</span>
                    <p className="text-white">Ekransız bölgeler oluşturun (yemek masası, yatak odası)</p>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-xl p-5">
                  <div className="flex items-center">
                    <span className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white text-sm font-bold rounded-full mr-4">2</span>
                    <p className="text-white">Günlük ekran süresi limitleri belirleyin</p>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-xl p-5">
                  <div className="flex items-center">
                    <span className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white text-sm font-bold rounded-full mr-4">3</span>
                    <p className="text-white">Rol model olun - kendi ekran kullanımınızı gözden geçirin</p>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-xl p-5">
                  <div className="flex items-center">
                    <span className="w-8 h-8 flex items-center justify-center bg-teal-500 text-white text-sm font-bold rounded-full mr-4">4</span>
                    <p className="text-white">Birlikte yapılacak ekransız aktiviteler planlayın</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Çocuğunuzun Dijital Dengesi İçin Destek Alın
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Ekran bağımlılığı konusunda endişeleriniz mi var? Birlikte çocuğunuz için sağlıklı bir dijital yaşam oluşturabiliriz.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-teal-500 text-white font-medium rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Randevu Al
              <i className="ri-calendar-line ml-2"></i>
            </Link>
            <Link
              to="/hizmetler"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-gray-100 text-gray-900 font-medium rounded-full hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              Tüm Hizmetler
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
